import { Checkbox, Label } from '@roger/ui-components';
import type { RoleProduct } from '../../constants/products';

const ROLE_PRODUCT_LABELS: Record<RoleProduct, string> = {
  core: 'Every agency',
  emr: 'RogerEMR',
  scribe: 'Scribe',
  intake: 'Intake',
  coding: 'Medical coding',
  goals: 'Kinnser goals',
  'goals:worksheet': 'Worksheet goals',
  'goals:inline': 'Inline goals',
  fax: 'eFax',
};

const ROLE_PRODUCT_OPTIONS = Object.entries(ROLE_PRODUCT_LABELS) as [
  RoleProduct,
  string,
][];

type Props = {
  idPrefix: string;
  value: RoleProduct[];
  onChange: (value: RoleProduct[]) => void;
  disabled?: boolean;
};

/** Which products a role is for. A role is offered only where the agency has one. */
const RoleProductsPicker: React.FC<Props> = ({
  idPrefix,
  value,
  onChange,
  disabled,
}) => {
  const toggle = (product: RoleProduct, checked: boolean) =>
    onChange(
      checked
        ? [...value.filter(p => p !== product), product]
        : value.filter(p => p !== product)
    );

  return (
    <div className='space-y-1.5'>
      <Label>
        Products <span className='text-red-500'>*</span>
      </Label>
      <p className='text-xs text-muted-foreground'>
        Offered only at agencies with one of these products.
      </p>
      <div className='grid grid-cols-1 gap-2 pt-1 sm:grid-cols-2'>
        {ROLE_PRODUCT_OPTIONS.map(([product, label]) => {
          const id = `${idPrefix}-${product}`;
          return (
            <div key={product} className='flex items-center gap-2'>
              <Checkbox
                id={id}
                checked={value.includes(product)}
                onCheckedChange={checked => toggle(product, !!checked)}
                disabled={disabled}
              />
              <Label htmlFor={id} className='font-normal'>
                {label}
              </Label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RoleProductsPicker;
